import { render, staticRenderFns } from "./DocDrawer.vue?vue&type=template&id=9ca3c65c&scoped=true&"
import script from "./DocDrawer.vue?vue&type=script&lang=js&"
export * from "./DocDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DocDrawer.vue?vue&type=style&index=0&id=9ca3c65c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca3c65c",
  null
  
)

export default component.exports